import React, { useRef, useEffect } from 'react';
import { GridType } from '../types';

interface GridSettingsProps {
  cols: number;
  setCols: (cols: number) => void;
  gridType: GridType;
  setGridType: (type: GridType) => void;
  showColsMenu: boolean;
  setShowColsMenu: (show: boolean) => void;
  showGridMenu: boolean;
  setShowGridMenu: (show: boolean) => void;
}

const GridSettings: React.FC<GridSettingsProps> = ({
  cols,
  setCols,
  gridType,
  setGridType,
  showColsMenu,
  setShowColsMenu,
  showGridMenu,
  setShowGridMenu,
}) => {
  const colsRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);

  const gridTypeLabels: Record<GridType, string> = {
    none: '无格线',
    square: '方格',
    tian: '田字格',
    mi: '米字格'
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (colsRef.current && !colsRef.current.contains(target)) {
        setShowColsMenu(false);
      }
      if (gridRef.current && !gridRef.current.contains(target)) {
        setShowGridMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setShowColsMenu, setShowGridMenu]);

  return (
    <div className="bg-white rounded-xl shadow-sm p-3 mb-1">
      <div className="flex justify-between gap-4">
        <div className="flex-1 relative" ref={colsRef}>
          <button
            onClick={() => {
              setShowColsMenu(!showColsMenu);
              setShowGridMenu(false);
            }}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm flex justify-between items-center"
          >
            <span>每行{cols}字</span>
            <i className="fa fa-caret-down text-xs"></i>
          </button>
          {showColsMenu && (
            <div className="absolute z-50 left-0 mt-2 w-full bg-white rounded-lg shadow-lg border border-gray-100 py-1">
              {[1, 2, 3, 4].map((num) => (
                <div
                  key={num}
                  onClick={() => {
                    setCols(num);
                    setShowColsMenu(false);
                  }}
                  className="px-3 py-2 text-sm hover:bg-gray-50 cursor-pointer"
                >
                  每行{num}字
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="flex-1 relative" ref={gridRef}>
          <button
            onClick={() => {
              setShowGridMenu(!showGridMenu);
              setShowColsMenu(false);
            }}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm flex justify-between items-center"
          >
            <span>{gridTypeLabels[gridType]}</span>
            <i className="fa fa-caret-down text-xs"></i>
          </button>
          {showGridMenu && (
            <div className="absolute z-50 left-0 mt-2 w-full bg-white rounded-lg shadow-lg border border-gray-100 py-1">
              {(Object.keys(gridTypeLabels) as GridType[]).map((type) => (
                <div
                  key={type}
                  onClick={() => {
                    setGridType(type);
                    setShowGridMenu(false);
                  }}
                  className="px-3 py-2 text-sm hover:bg-gray-50 cursor-pointer"
                >
                  {gridTypeLabels[type]}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GridSettings;
